import translator from 'src/translate'
import { withStyles } from '@material-ui/core/styles'
import React, { useState, useRef } from 'react'
import styles from '../../styles'
import { useDispatch } from 'react-redux'
import { Typography, OutlinedInput, TextField } from '@material-ui/core'
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate'
import URL from 'src/api/url/api'
import DeleteIcon from '@material-ui/icons/Delete'
const TitleLogo = props => {
  const {
    classes,
    assignmentTitle,
    handleTextFieldChange,
    logo,
    handleClickAddLogo,
    onLogoUpload,
    setLogo,
    logoRef,
    assignmentDescription,
    handleTextFieldChangeDescription,
  } = props

  return (
    <div>
      <div
        style={{
          borderBottom: 'solid 1px #ededed',
          marginBottom: '16px',
          height: '32px',
        }}
      >
        <Typography
          variant="subtitle2"
          style={{ marginTop: '4px', marginBottom: '4px' }}
        >
          Title & Logo
        </Typography>
      </div>
      <OutlinedInput
        sx={{
          borderColor: 'black',
          width: '-webkit-fill-available',
          marginBottom: '16px',
          height: '40px',
        }}
        defaultValue={assignmentTitle}
        placeholder={translator._('assignment.assignmentName')}
        onChange={handleTextFieldChange}
      />
      <div
        className={classes.root__section}
        style={{
          justifyContent: 'flex-start',
          gap: '0.7rem',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        <div className={classes.image__bg}>
          {!logo && (
            <div className={classes.image__icon}>
              <AddPhotoAlternateIcon
                fontSize="inherit"
                style={{ fontSize: '2rem' }}
              />
              <span className={classes.image__span}>Add Logo</span>
            </div>
          )}
          <div className={classes.image__content}>
            {logo && (
              <img
                className={classes.image__img}
                alt=""
                src={`${URL.MEDIA}` + logo}
              />
            )}
          </div>
          {logo && (
            <div className={classes.image__remove} onClick={() => setLogo()}>
              <DeleteIcon fontSize="medium" />
            </div>
          )}

          {!logo && (
            <input
              type="file"
              className={classes.file__upload}
              onChange={onLogoUpload}
            />
          )}
        </div>
        <span className={classes.span__extension}>.png, .jpg, .gif</span>
      </div>
    </div>
  )
}

export default withStyles(styles)(TitleLogo)
